import React from 'react';
import ReactDOM from 'react-dom';
import FormItemUtil from '../../utils/FormItemUtil';
import AuthorityUtil from '../../utils/AuthorityUtil';
import GOTUtil from '../../utils/GOTUtil';
import UserFormSetForm from '../../userformset/UserFormSetForm';
import CmdTypeActions from '../../actions/CmdTypeActions';
import CommandActions from '../../actions/CommandActions';
import StringUtil from '../../utils/StringUtil';
import FormItemConst from '../FormItemConst';

export default class GongqiFormItemControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		this.classAlias = "GongqiFormItemControl";
		this.menuItemId = menuItemId;
		this.formId = formId;
		this.authorityKey = forLookup?module.formXML.name:menuItemId;
		this.parentXML = parent;
		this.xml = xml;
		this.innerId = xml.id;
		this.group = group;
		this.groupAlias = group!=null?group.groupAlias:"";
		this.parentControl = null;
		this.childrenControl = [];
		this.forLookup = forLookup;
		this.controlId = "ctrl_" + this.xml.name;
		
		this.module = module;
		var _key = FormItemUtil.getFormStoresKey(this.menuItemId,this.formId);
		var formStore = window.parent.window[_key];
		this.properties = formStore.mapItemProperty[this.formId+"_"+this.xml.id];
		
		this.contextMenuData = {
          items: [
            //{label:'隐藏',icon:'',action:this.hide.bind(this)},
            //{label:'显示',icon:'',action:this.show.bind(this)},
			{label:'调整布局',icon:'',action:this.formAdjust.bind(this)}
			// {label:'画面调整(含列宽)',icon:'',action:this.formAdjust2.bind(this)}
          ]
        };
	}

	setControlSkipTabCmd(skip)
	{
		this._cmdSkipTab = skip;
		try
		{
			if(this.childrenControl)
			{
				for(let i = 0;i<this.childrenControl.length;i++)
				{
					let childControl = this.childrenControl[i];
					if(childControl && childControl.setControlSkipTabCmd)
						childControl.setControlSkipTabCmd(skip);
				}
			}
		}
		catch(e)
		{

		}
	}

	hide()
	{
		alert("hide");
	}

	show()
	{
		alert("show");
	}

	formAdjust()
	{
		ReactDOM.render(<UserFormSetForm />,document.getElementById('userFormSetDiv'));
		$("#userFormSetDiv").css("display","flex");
	    //$("body").mLoading({text:"正在加载界面调整..."});
	    //$("#userFormSetDiv").load("userformset/userformset.html").css("display","flex");
	}

	formAdjust2()
	{
		//this.allUserProperties["50023"] = {displayLength:50};
		let columnProperties = {};
		CommandActions.getColumnLengthProperties(columnProperties);
		ReactDOM.render(<UserFormSetForm columnProperties={columnProperties} />,document.getElementById('userFormSetDiv'));
		$("#userFormSetDiv").css("display","flex");
	}

	getProperty_Width()
	{
		var _parentWindow = window.parent.window;
	    if(!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
	    {
	      let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
	      let _properties = _userProperties[this.xml.id];
	      if(_properties && _properties.hasOwnProperty("width"))
	        return _properties["width"];
		}
		if(!this.properties.Width || this.properties.Width==-1)
			return "";
		return this.properties.Width;
	}

	getProperty_HelpText()
	{
		return this.properties.HelpText;
	}
	getProperty_EnumType()
	{
		return GOTUtil.getPropertyValue(this.xml,"EnumType");
	}

	getProperty_CSSStyle()
	{
		if(this.properties.hasOwnProperty("CSSStyle"))
			return this.properties.CSSStyle;
		return "";
	}

	getProperty_Height()
	{
		var _parentWindow = window.parent.window;
	    if(!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
	    {
	      let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
	      let _properties = _userProperties[this.xml.id];
	      if(_properties && _properties.hasOwnProperty("height"))
	        return _properties["height"];
		}
		if(!this.properties.Height || this.properties.Height==-1)
			return "";
		return this.properties.Height;
	}

	getProperty_HideInVisible()
	{
		var _parentWindow = window.parent.window;
		if(!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			let _properties = _userProperties[this.xml.id];
			if(_properties && ( _properties.hasOwnProperty("hideinvisible") || _properties.hasOwnProperty("hideInVisible") ))
			{
				let _value = _properties["hideinvisible"] || _properties["hideInVisible"];
				if(typeof(_value) == "string")
					return _value=="true"?true:false;
			}
			//return _properties["hideInVisible"];
		}
		if(this.properties.hasOwnProperty("HideInvisible"))
			return this.properties.HideInvisible;
		return !this.properties.PlaceHolder;
	}

	getProperty_Label(showLabel = true)
	{
		if(this._cmdLabel)
			return this._cmdLabel;
		var _parentWindow = window.parent.window;
		if(!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			let _properties = _userProperties[this.xml.id];
			if(_properties && _properties.hasOwnProperty("label"))
				return _properties["label"];
		}
		return this.properties.Label;
	}

	getProperty_ShowLabel()
	{
		return this.properties.ShowLabel;
	}

	getProperty_AllowEdit_GOT()
	{
		if(typeof(this.properties.AllowEdit) == "string")
		{
			if(this.properties.AllowEdit == FormItemConst.ALLOWEDIT_ALWAYS)
				return true;
			else if(this.properties.AllowEdit == FormItemConst.ALLOWEDIT_NEVER)
				return false;
			else if(this.properties.AllowEdit == FormItemConst.ALLOWEDIT_ONLYONCREATE)
				return false;
		}
		
		return this.properties.AllowEdit;
	}

	getActualParentItemId()
	{
		return this.xml.parentId;
	}

	getProperty_AllowEdit_Loop()
	{
		var parentItemId = this.getActualParentItemId();
		var key = FormItemUtil.getFormItemControlKey(this.menuItemId,this.formId,parentItemId);
		var parentControl = FormItemUtil.getFormItemControl(key,this.forLookup);

		if(parentControl._cmdEditFalse == true)
			return false;

		return parentControl.getProperty_AllowEdit_GOTFinal();
	}

	getProperty_AllowEdit_GOTFinal()
	{
		if(this.finalAllowEditGOT)
			return this.finalAllowEditGOT;
		
		var result = this.getProperty_AllowEdit_GOT();
		if(!result)
			return false;
		
		result = this.getProperty_AllowEdit_Loop();
		this.finalAllowEditGOT = result;
		return result
		
	}

	getProperty_AllowEdit_CurrentRecordLocked()
	{
		return false;
	}

	getProperty_AllowEdit_UserSet()
	{
		let _parentWindow = window.parent.window;
		let _key = window.menuItemId+"."+window.formId;
		if(_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(_key))
		{
			let allUserProperties = _parentWindow.userProperties[_key];
			if(allUserProperties)
			{
				let thisProperties = allUserProperties[this.xml.id];
				if(thisProperties)
				{
					let _value = "";
					if(thisProperties.hasOwnProperty("allowEdit"))
					{
						_value = thisProperties.allowEdit;
						if(_value == false || _value == "false")
							return false;
					}
					else if(thisProperties.hasOwnProperty("allowedit"))
					{
						_value = thisProperties.allowedit;
						if(_value == false || _value == "false")
							return false;
					}
						
				}
			}	
		}
		//若没有进行过用户设置 则找寻GOT属性的代码应该在权限及用户覆写的下面
		return true;
	}

	getProperty_Visible_UserSet()
	{
		let _parentWindow = window.parent.window;
		let _key = window.menuItemId+"."+window.formId;
		if(_parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(_key))
		{
			let allUserProperties = _parentWindow.userProperties[_key];
			if(allUserProperties)
			{
				let thisProperties = allUserProperties[this.xml.id];
				if(thisProperties && thisProperties.hasOwnProperty("visible") && (thisProperties.visible == false || thisProperties.visible == "false"))
					return false;
			}	
		}
		//若没有进行过用户设置 则找寻GOT属性的代码应该在权限及用户覆写的下面
		return true;
	}

	getProperty_AllowEdit_UserSetLoop()
	{
		var parentItemId = this.getActualParentItemId();
		var key = FormItemUtil.getFormItemControlKey(this.menuItemId,this.formId,parentItemId);
		var parentControl = FormItemUtil.getFormItemControl(key,this.forLookup);
		return parentControl.getProperty_AllowEdit_UserSetFinal();
	}

	getProperty_AllowEdit_UserSetFinal()
	{
		var result = this.getProperty_AllowEdit_UserSet();
		if(!result)
		{
			return false;
		}
		result = this.getProperty_AllowEdit_UserSetLoop();
		return result;
	}

	finalVisible = true;
	finalVisibleInited = false;

	getProperty_Visible_FinalWithOutUserSet()
	{
		if(this.finalVisibleInited)
			return this.finalVisible;
		var result = this.getProperty_AuFinal("visible");
		if(result)
			result = this.getProperty_Visible_GOTFinal();
		
		this.finalVisible = result;
		this.finalVisibleInited = true;
		return result;
	}

	getProperty_Visible_GOTFinal()
	{
		var result = this.getProperty_Visible();
		if(!result)
			return false;
		result = this.getProperty_Visible_GOT();
		if(!result)
			return false;
		if(this.classAlias != "FormItemDesignControl")
			result = this.getProperty_Visible_Loop();
		return result;
	}

	getProperty_Visible_Loop()
	{
		var gongqiFormItemP = this.getActualParentItemControl();
		if(!gongqiFormItemP)return true;
		return gongqiFormItemP.getProperty_Visible_GOTFinal();
	}

	getProperty_Visible()
	{
		return this.properties.Visible;
	}

	getProperty_Visible_GOT()
	{
		return this.properties.Visible;
	}
		

	getActualParentItemControl()
	{
		var parentItemId = this.getActualParentItemId();
		var key = FormItemUtil.getFormItemControlKey(this.menuItemId,this.formId,parentItemId);
		var parentControl = FormItemUtil.getFormItemControl(key,this.forLookup);
		return parentControl;
	}

	getProperty_AuFinal(type)
	{
		if(this && this.group && this.group.forLookup == true){
			return true;
		}
		var _parentWindow = window.parent.window;
		if(_parentWindow.userInfos.isAdmin == true)
			return true;
		
		var finalValue = true;var isForbidden = false;var finalValueSetted = false;
		var au = AuthorityUtil.getXmlType2SCacheItem(window.menuItemId,this.xml.id,type);
		
		if(au["isDefault"] == false)
		{
			finalValue = au["result"];
			finalValueSetted = true;
			isForbidden = au["isForbidden"];
		}
		
		if(isForbidden)
			return false;
		
		var parentControl = this.getActualParentItemControl();
		
		while(parentControl)
		{
			au = AuthorityUtil.getXmlType2SCacheItem((window.menuItemId&&window.menuItemId!="")?window.menuItemId:window.formXML.name,parentControl.xml.id,type);
			
			if(au["isDefault"] == false)
			{
				if(!finalValueSetted)
				{
					finalValue = au["result"];
					finalValueSetted = true;
				}
				
				isForbidden = au["isForbidden"];
			}
			
			if(isForbidden)
				return false;
			
			parentControl = parentControl.getActualParentItemControl();
		}
		
		return finalValue && !isForbidden;
	}

	getProperty_AllowEdit_Final()
	{
		//if(this.forLookup)return true;
		if(this.group && this.group.mainSource.isAggreateTable == true)
						//&& this.group.mainSource.isPivotTable == false)
			return false;
		
		if(this._cmdEditFalse == true)
			return false;
		if(this._cmdConditionTaskEditFalse == true)
			return false;
		//TODO EditMode调整
		// if(!getEditMode())
		// 	return false;
		
		if(this.getProperty_AllowEdit_CurrentRecordLocked() == true)
			return false;
		
		var result = this.getProperty_AllowEdit_UserSetFinal();
		if(!result)
			return false;
		result = this.getProperty_AuFinal("edit");
		if(result)
		{
			result = this.getProperty_AllowEdit_GOTFinal();
		}
		return result;
	}

	getProperty_Visible_UserSetFinal()
	{
		var result = this.getProperty_Visible_UserSet();
		if(!result)
		{
			return false;
		}
		return result;
		
	}

	getProperty_Visible_UserSetLoop()
	{
		var parentItemId = this.getActualParentItemId();
		var key = FormItemUtil.getFormItemControlKey(this.menuItemId,this.formId,parentItemId);
		var parentControl = FormItemUtil.getFormItemControl(key,this.forLookup);
		return parentControl.getProperty_Visible_UserSetFinal();
	}

	getProperty_Visible_UserSetFinalLoop()
	{
		var result = this.getProperty_Visible_UserSet();
		if(!result)
			return false;
		if(!(this.classAlias ==  "FormItemDesignControl"))
		{
			result = this.getProperty_Visible_UserSetLoop();
		}
		return result;
	}

	getProperty_Visible_Final()
	{
		if(this._cmdVisibleFalse == true)
			return false;
		var result = this.getProperty_Visible_UserSetFinalLoop();
		if(!result)
			return false;
		return this.getProperty_Visible_FinalWithOutUserSet();
	}

	finalVisibleUsInited = false;
	finalVisibleUs = true;
	getProperty_Visible_FinalusersetLoopForSkip()
	{
		if(this.finalVisibleUsInited)
			return this.finalVisibleUs;
		var result = this.getProperty_Visible_UserSetFinalLoop();
		if(result)
			result = this.getProperty_Visible_GOTFinal();
		this.finalVisibleUs = result;
		this.finalVisibleUsInited = true;
		return result;
	}

	
	isSkipTab()
	{
		return true;
	}

	getProperty_SkipTab()
	{
		if(this._cmdSkipTab != undefined)
			return this._cmdSkipTab;

		var _parentWindow = window.parent.window;
		if(!this.forLookup && _parentWindow.userProperties && _parentWindow.userProperties.hasOwnProperty(window.menuItemId+"."+window.formId))
		{
			let _userProperties = _parentWindow.userProperties[window.menuItemId+"."+window.formId];
			let _properties = _userProperties[this.xml.id];
			if(_properties && ( _properties.hasOwnProperty("skiptab")||_properties.hasOwnProperty("skipTab") ))
			{
				let _value;
				if(_properties.hasOwnProperty("skiptab"))
					_value = _properties["skiptab"];
				else
					_value = _properties["skipTab"];
				if(typeof(_value)=="string")
				{
					return _value == "true"?true:false;
				}
				return _value;
			}
		}

		if(this.properties.hasOwnProperty("SkipTab"))
			return this.properties.SkipTab;
		return false;
	}
	
	getProperty_ActualSkipTab()
	{
		if(this.getProperty_SkipTab())
			return true;
		
		var parent = this.parentControl;
		while(parent)
		{
			if(parent.getProperty_SkipTab())
				return true;
			parent = parent.parentControl;
		}
		
		return false;
	}
	
	getComponentInstance(parent,forLookup)
	{

	}

	getCommonProps()
	{
		return {controlVisible:this.getProperty_Visible_Final(),hideInVisible:this.getProperty_HideInVisible()};
	}

	getStyle()
	{
		let _style = {};
		//if(!this.getProperty_Visible_Final())
		//	_style["visibility"] = "hidden";
		let cssStylePro = this.getProperty_CSSStyle();
		//let jsonStyle = JSON.parse(cssStylePro);
		if(cssStylePro)
		{
			let cssStyleObject = {};
			let styles = cssStylePro.split(";");
			for(let i = 0;i<styles.length;i++)
			{
				let singleStyle = styles[i];
				if(singleStyle)
				{
					let singleStyles = singleStyle.split(":");
					let styleName = singleStyles[0];
					let styleValue = singleStyles[1];
					let origStyleName = StringUtil.trimThrough(styleName);
					styleName = StringUtil.convertStyleToReactStyle(origStyleName);
					cssStyleObject["orig-"+styleName] = origStyleName;
					cssStyleObject[styleName] =  styleValue;
				}
			}
			Object.assign(_style,cssStyleObject);
		}
		
		return _style;
	}

	//判断子级是否包含诸如Tab DataGrid HtmlPlugin等固定百分百控件
	containsMaxControl(item,layout)
	{
		let children = item.FormItem;
		if(children == null || children == undefined)
			return false;
		for(var i=0;i<children.length;i++)
		{
			let child = children[i];
			//if(child.type == "Tab")
			//	return true;

			if(child.type == "DataGrid")
			{
				if(layout == "vertical")
				{
					return GOTUtil.getPropertyValue(child,"Rows") == "";
				}
				else if(layout == "horizontal")
					return true;
			}

			if(child.type == "Plugin")
			{
				if(layout == "vertical")
				{
					let _height = GOTUtil.getPropertyValue(item,"Height");
					if(!_height)
						return true;
				}
				else
				{
					let _width = GOTUtil.getPropertyValue(item,"Width");
					if(!_width)
						return true;
				}
			}
			let childLayout = GOTUtil.getPropertyValue(child,"Layout");
			if(!childLayout)
				continue;
			if(this.containsMaxControl(child,childLayout))
				return true;
		}
		return false;
	}

	containsMaxControlForHeight(item)
	{
		let children = item.FormItem;
		if(children == null || children == undefined)
			return false;
		for(var i=0;i<children.length;i++)
		{
			let child = children[i];
			if(child.type == "DataGrid")
			{
				if(GOTUtil.getPropertyValue(child,"Rows") == "")return true; 
				/*if(this.module.hasUpDownDataGrid)
				{
					if(GOTUtil.getPropertyValue(child,"Rows") == "16")return true; 
				}
				else
				{
					return true;
				}*/
			}
			//TODO 需要根据Plugin实际情况来判断是否属于最大化控件
			if(child.type == "Plugin")
			{
				let pluginType = GOTUtil.getPropertyValue(child,"PluginType");
				if(pluginType == "Radio")
					continue;
				let _height = GOTUtil.getPropertyValue(child,"Height");
				if(!_height)
					return true;
			}
			if(this.containsMaxControlForHeight(child))
				return true;
		}
		return false;
	}

	containsMaxControlForWidth(item)
	{
		let children = item.FormItem;
		if(children == null || children == undefined)
			return false;
		for(var i=0;i<children.length;i++)
		{
			let child = children[i];
			if(child.type == "Tab" || child.type == "DataGrid")
				return true;
			//TODO 需要根据Plugin实际情况来判断是否属于最大化控件
			if(child.type == "Plugin")
			{
				let _width = GOTUtil.getPropertyValue(child,"Width");
				if(!_width)
					return true;
			}
			if(this.containsMaxControlForWidth(child))
				return true;
		}
		return false;
	}

	isVerticalNotFirst()
	{
		if(this.parentControl)
		{
			if(this.parentXML.Properties.Layout.Value == "vertical")
			{
				var firstItem = this.parentXML.FormItem[0];
				if(firstItem.id != this.xml.id && this.containsMaxControl(firstItem))
					return true;
			}
			return this.parentControl.isVerticalNotFirst();
		}
		return false;
	}

	doSetEnableCmd(value)
	{
		this._cmdEditFalse = !value;
		if(this.childrenControl && this.childrenControl.length>0)
		{
			var finalValue = this.getProperty_AllowEdit_Final();
			for(let i = 0;i<this.childrenControl.length;i++)
			{
				var item = this.childrenControl[i];

				if(item.classAlias && item.classAlias.indexOf("Editor") != -1)
				{
					CmdTypeActions.updateControlAllowEdit(item.xml.name,finalValue,this.moduleInstanceId);	
				}
				else if(item.doSetEnableCmd)
				{
					item.doSetEnableCmd(value);
				}
				
			}
		}
	}

	isUnderQueryGroup()
	{
		var targetParent = this.parentControl;
		
		while(targetParent && targetParent.classAlias && targetParent.classAlias != "FormItemDesignControl")
		{
			if(targetParent.classAlias == "FormItemGroupControl")
			{
				if(targetParent.getProperty_GroupType() == "Query")
				{
					return true;
				}
			}
			
			targetParent = targetParent.parentControl;
		}
		return false;
	}

	isSameMainSource(baseGroup)
	{
		if(this.group != baseGroup)
			return false;
		let datasourcepro  = GOTUtil.getProperty(this.xml,"DataSource");
		if(!datasourcepro)
			return false;
		var datasource = datasourcepro.Value;
		return datasource == baseGroup.groupAlias?true:false;
	}

	setControlProperty(name,value)
	{

	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/GongqiFormItemControl.js